const AppActions = {
  APP_MOUNTED: 'app/mounted',
  APP_AUTH_RESET: 'app/authReset',
  FETCH_TRANSLATIONS: 'translations/fetch',
  APP_SIGN_OUT: 'app/signOut',
  APP_REDIRECT_URL: 'app/redirectUrl',
  FETCH_CLIENT_METADATA: 'app/clientMetadata',
};

export {
  AppActions,
};
